import UserRepository from '@/api/UserRepository';
import User from '@/api/mjegb/User';
import { BehaviorSubject, interval, Observable, Subject, Subscription } from 'rxjs';
import Message from '@/util/Message';
import Resource from '@/api/Resource';

export default class GlobalState {
    public currentUser: User | null = null;

    public get messageBus(): Observable<Message> {
        return this.messageBusSubject.asObservable();
    }

    private readonly _loginEndpoint: string;
    private readonly _userSubject = new BehaviorSubject<Resource<User>>(Resource.loading<User>(null));
    private readonly _userRepository: UserRepository;
    private readonly _keepAliveSubscription = new Subscription();
    private readonly messageBusSubject = new Subject<Message>();

    public constructor(userRepository: UserRepository, loginEndpoint: string) {
        this._loginEndpoint = loginEndpoint;
        this._userRepository = userRepository;
        this._userSubject.subscribe((resource) => {
            if (resource.isSuccess) {
                this.currentUser = resource.data;
            }
        });
        this.refreshCurrentUser();
        this._keepAliveSubscription = interval(10 * 60 * 1000).subscribe(() => this._userRepository.getSelf());
    }

    public beginLogin(): void {
        window.location.href = this._loginEndpoint;
    }

    public beginLogout(): void {
        this._userRepository.logout().subscribe((resource) => {
            if (resource.isSuccess && resource.data) {
                window.location.href = resource.data.logoutUrl;
            }
        });
    }

    public refreshCurrentUser(): void {
        this._userRepository.findCurrent().subscribe((resource) => {
            this._userSubject.next(resource);
        });
    }

    public get userObservable(): Observable<Resource<User>> {
        return this._userSubject.asObservable();
    }

    public emitOnMessageBus(message: Message): void {
        this.messageBusSubject.next(message);
    }
}
